export interface Refusal {
  readonly code: string;
  /** Данные случая: ключи `detail`, кроме `code` и `message`. */
  readonly data: Readonly<Record<string, unknown>>;
}

/** Разобрать уже распарсенное JSON-тело; `null`, если `detail` не объект со строковым `code`. */
export function parseRefusal(body: unknown): Refusal | null {
  if (!isRecord(body)) {
    return null;
  }
  const detail = body.detail;
  if (!isRecord(detail) || typeof detail.code !== "string") {
    return null;
  }
  const data: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(detail)) {
    if (key !== "code" && key !== "message") {
      data[key] = value;
    }
  }
  return { code: detail.code, data };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** Прочитать тело ответа; не-JSON / `detail` не-объект / список `422` → `null`. Тело не потребляет (`response.clone()`). */
export async function readRefusal(response: Response): Promise<Refusal | null> {
  try {
    return parseRefusal(await response.clone().json());
  } catch {
    return null;
  }
}

export class ApiError extends Error {
  public readonly status: number;
  public readonly code: string | null;
  public readonly data: Readonly<Record<string, unknown>>;

  public constructor(status: number, message: string, refusal: Refusal | null) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = refusal === null ? null : refusal.code;
    this.data = refusal === null ? {} : refusal.data;
  }
}

/** `ApiError` по ответу; `message` — технический `"<context>: HTTP <status>"`. */
export async function apiErrorFromResponse(
  response: Response,
  context: string,
): Promise<ApiError> {
  return new ApiError(
    response.status,
    `${context}: HTTP ${response.status}`,
    await readRefusal(response),
  );
}
